module.exports = __webpack_public_path__ + "img/gaungdianbiaozhi.4e56b898.png";